import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  triggerProjectDetailRefresh: false,
  triggerStatsRefresh: false,
  allCandidates: 0,
  importedCandidates: 0,
  shortlistedCandidates: 0,
  rejectedCandidates: 0,
};

// Redux Toolkit slice
const talentPoolSlice = createSlice({
  name: "pool",
  initialState,
  reducers: {
    toggleProjectDetailRefresh: (state) => {  // Changed the action name
      // Toggle the value of triggerProjectDetailRefresh
      state.triggerProjectDetailRefresh = !state.triggerProjectDetailRefresh;
    },
    toggleStatsRefresh: (state) => {  // Changed the action name
      // Toggle the value of triggerStatsRefresh
      state.triggerStatsRefresh = !state.triggerStatsRefresh;
    },
    setAllCandidates: (state, action) => {
      state.allCandidates = action.payload;
    },
    setImportedCandidates: (state, action) => {
      state.importedCandidates = action.payload;
    },
    setShortlistedCandidates: (state, action) => {
      state.shortlistedCandidates = action.payload;
    },
    setRejectedCandidates: (state, action) => {
      state.rejectedCandidates = action.payload;
    },
  },
});

// Export the actions
export const {
  toggleProjectDetailRefresh,
  setAllCandidates,
  setImportedCandidates,
  setShortlistedCandidates,
  setRejectedCandidates,
  toggleStatsRefresh
} = talentPoolSlice.actions; // Updated action name

// Export the reducer
export default talentPoolSlice.reducer;
